import { Component, computed, effect, inject, Input, OnInit } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import { DistributionSection } from '@ottobock/shared/domain';

import { RolloutPlanStore } from '../../../+state/rollout/rollout-plan-form.store';
import { useRolloutPlanStore } from '../../../+state/rollout/rollout-plan.store';
import { formatAccess, formatCompatibleVersions } from '../../../helpers';
import { RolloutPlanGroupedBtFriendlyNames } from '../../../infrastructure/types/rollout-plan.type';

@Component({
  selector: 'remote-update-domain-app-rollout-plan-summary',
  templateUrl: './rollout-plan-summary.html',
  styleUrls: ['./rollout-plan-summary.css'],
  imports: [
    DistributionSection,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatCell,
    MatCellDef,
    MatRow,
    MatRowDef
  ]
})
export class RolloutPlanSummary implements OnInit {
  private rolloutPlanGlobalStore = inject(RolloutPlanStore);
  private rolloutPlanApiStore = inject(useRolloutPlanStore);
  public allFormData = computed(() => this.rolloutPlanGlobalStore.getAllFormData());
  public productGroupsWithPercentages = computed(() =>
    this.rolloutPlanGlobalStore.mergedProductGroupsWithPercentages()
  );
  public groupBtFriendlyNames = computed(() =>
    this.rolloutPlanGlobalStore.groupedBtFriendlyNames()
  );
  @Input() currentSection = '';

  isEditingRolloutPlan = computed(() => this.rolloutPlanGlobalStore.isEditingRolloutPlan());

  displayedColumns = ['targetProductGroups', 'btFriendlyNames'];
  dataSource = new MatTableDataSource<RolloutPlanGroupedBtFriendlyNames>([]);

  public firmwarePackageDetails = computed(() => {
    if (this.isEditingRolloutPlan()) {
      const details = this.rolloutPlanApiStore.rolloutPlanDetails().data;
      if (details) {
        return {
          id: details.packageId,
          version: details.packageVersion,
          distribution: details.packageDistribution,
          compatibleVersions: details.compatibleVersions
        };
      }
    }

    const selectedPackageId = this.allFormData().planDetails.firmwarePackageId;
    const allEligiblePackages =
      this.rolloutPlanApiStore.allRolloutPlanEligiblePackages().data ?? [];
    return allEligiblePackages.find(firmware => firmware.id === selectedPackageId);
  });

  formattedAccess = computed(() => {
    const details = this.firmwarePackageDetails();
    return details?.distribution?.access ? formatAccess(details.distribution?.access) : '';
  });

  formatCompatibleVersions = computed(() => {
    const details = this.firmwarePackageDetails();
    return details?.compatibleVersions ? formatCompatibleVersions(details?.compatibleVersions) : [];
  });

  ngOnInit() {
    const data = this.allFormData();
    const allDataIsValid =
      data.planDetails.isValid && data.productGroups.isValid && data.distributionSettings.isValid;
    this.rolloutPlanGlobalStore.updateSummary(allDataIsValid);
  }

  constructor() {
    effect(() => {
      this.dataSource.data = this.groupBtFriendlyNames();
    });
  }
}
